import React from "react";

import { analytics } from "../Main/Helpers/firebase";

export const BlankLink = ({ href, children }) => {
  return (
    <a
      href={href}
      target="_parent"
      onClick={() =>
        analytics.logEvent("exit_form", {
          destination: href
        })
      }
    >
      {children}
    </a>
  );
};
